<template>
    <div class="page-container">
        <vue-title :title="title" :brand="true"></vue-title>
        <div class="qr-container">
            <video ref="qrFeed">

            </video>

            <div class="qr-overlay">
            </div>

            <div class="qr-scan-success"
                :class="{'fade-out': scanSuccessCheckFading}"
                v-if="showScanSuccessCheck"
                aria-hidden="true">
                <div class="qr-scan-success-check">

                </div>
            </div>

            <div class="qr-tools">
                <div class="button-group">
                    <button :class="{'active': mode == 'scanner'}"
                            @click="mode = 'scanner'">
                        Scan
                    </button>
                    <button :class="{'active': mode == 'check'}"
                            v-if="settings.ShowCheckButton"
                            @click="mode = 'check'">
                        Check
                    </button>
                    <button :class="{'active': mode == 'leads'}"
                            @click="switchToLeadMode">
                        {{ settings.ViewLeadsLabel }}
                    </button>
                </div>
            </div>

            <div class="qr-bottom-tools">
                {{ settings.CustomScanName }}
            </div>

            <div class="qr-loading"
                v-show="submitting">
                <loading>

                </loading>
            </div>


            <div class="qr-check"
             v-if="qrCheckResults">
                <div class="qr-check-results">
                    <h4>{{ qrCheckResults.Title }}</h4>
                    <h5 v-if="qrCheckResults.ScanDateTime">
                        ✅ Scanned at {{ qrCheckResults.ScanDateTime }}.
                    </h5>
                    <h5 v-else>
                        ❌ No Scan Recorded
                    </h5>
                    <button @click="qrCheckResults = null">
                        Close
                    </button>
                </div>
            </div>

            <div class="qr-check"
                v-if="lead && !this.submitting">
                
                <div class="qr-check-results">
                    <div class="lead-form">
                        <div class="attendee-lead-header">
                            <img-g :src="`${getApiUrl()}/api/asset/${showCode}/attendee/${lead.AttendeeCode}/profile`"
                                fallbackSrc="/img/person.png"></img-g>
                            <div class="detail-page-bio" v-if="!allowEditInformation">
                                <h1 class="title">
                                    {{lead.Attendee.DisplayName}}
                                </h1>
                                <h2 v-if="lead.Attendee.Title"> 
                                    {{lead.Attendee.Title}}
                                </h2>
                                <h3 v-if="lead.Attendee.SubTitle">
                                    {{lead.Attendee.SubTitle}}
                                </h3>
                            </div>
                            <div class="detail-page-bio" v-else>
                                <label>First Name</label>
                                <input v-model="lead.Attendee.FirstName" @change="updateLeadDisplayName">
                                <label>Last Name</label>
                                <input v-model="lead.Attendee.LastName" @change="updateLeadDisplayName">
                                <label>Preferred Name</label>
                                <input v-model="lead.Attendee.DisplayName">
                                <label>{{settings.TitleFieldName}}</label>
                                <input v-model="lead.Attendee.Title">
                                <label>{{ settings.SubTitleFieldName }}</label>
                                <input v-model="lead.Attendee.SubTitle">
                            </div>
                        </div>

                        <template v-if="settings.CaptureNotes">
                            <div class="form-control">
                                <label>
                                    Notes
                                </label>
                                <textarea v-model="lead.Notes"
                                        aria-label="Notes"
                                        required
                                        :disabled="submitting"
                                        maxlength="10000">

                                </textarea>
                            </div>
                        </template>
                    </div>  

                    <div class="save-lead-buttons">
                        <button @click="cancelSave()">
                            Cancel
                        </button>
                        <button @click="saveLeadScan()">
                            Save
                        </button>
                    </div>
                </div>
            </div>

            <div class="qr-loading qr-error"
                v-show="error">
                <span>
                    {{ error }}
                </span>

                <button @click="error = null">
                    Dismiss
                </button>
            </div>


            <div class="search-box-overlay"
             v-if="mode == 'leads'">
                <div class="search-box">
                    <span class="icomoon">
                        
                    </span>
                    <input placeholder="Search" 
                        v-model="searchText"
                        ref="searchInput"
                        type="text"/>
                </div>
            </div>

            <div v-if="mode == 'leads'"
                class="lead-list custom-lead-list">
                <div class="header-actions">
                    <span class="title">
                        {{ settings.ViewLeadsLabel }}
                    </span>
                    <span class="scan-total">
                        Total scans: {{ leads.length }}
                    </span>
                    <div class="actions">
                        <button class="icomoon" @click="exportToCsv">
                            
                        </button>
                        <button class="icomoon" @click="switchToScanMode">
                            
                        </button>
                    </div>
                </div>

                <div class="item-list">
                    <div v-if="leads.length == 0">
                        No scans recorded.
                    </div>
                    <div v-for="item in filteredLeads"
                        :key="item.AttendeeCode"
                        class="favorite-list-item list-item scan-list-item"
                        @click="editLead(item)">
                        <div>
                            <img-g :src="`${getApiUrl()}/api/asset/${showCode}/attendee/${item.AttendeeCode}/profile`"
                                    class="round-photo"
                                fallbackSrc="/img/person.png" />
                            <div>
                                <span class="title">
                                    {{item.Attendee.DisplayName}}
                                </span>
                                <span class="subtitle"
                                        v-if="item.Attendee.Title">
                                    {{item.Attendee.Title}}
                                </span>
                                <span class="subtitle"
                                        v-if="item.Attendee.SubTitle">
                                    {{item.Attendee.SubTitle}}
                                </span>
                            </div>
                        </div>
                        <p class="lead-notes" v-if="item.Notes">
                            {{ item.Notes }}
                        </p>
                    </div>
                </div>
            </div>

            <div v-if="!mode"
                class="launch-page">
                <button @click="switchToScanMode">
                    Scan Badges
                </button>
                <button @click="switchToLeadMode">
                    {{ settings.ViewLeadsLabel }}
                </button>
            </div>

        </div>

        <router-view class="right-pane">

        </router-view>
    </div>
</template>
<script>
import QrScanner from 'qr-scanner'; 
import moment from 'moment'
import { AppState } from './appstate';
import Token from './authentication/token'
import Common from './common'
import { parseAttendeeBadgeScan } from './scan.helpers';


export default {
    props: ['sectionCode'],
    mixins: [
        Token,
        Common
    ],   

    data() {
        return {
            vendors: [],
            leads: [],

            selectedVendorCode: null,
            qrCheckResults: null,

            submitting: false,
            scanner: null,
            lastScannedText: null,
            showLastScannedText: false,
            scanStatus:"",
            showScanSuccessCheck: false,
            scanSuccessCheckFading: false,
            scanSuccessCheckTimer: null,
            error: null,
            mode: '',

            lead: null,
            searchText: '',
            allowEditInformation: false,
            scannerInput: '',
        }
    },


    computed: {
        title() {
            return AppState.show.Sections[this.sectionCode].Title;
        },

        showCode() {
            return AppState.showCode;
        },

        settings() {
            return AppState.show.Sections[this.sectionCode]?.Settings || {
                CustomScanName: "Scan",
                CustomScanCode: "NOSCANCODE",
                ViewLeadsLabel: "View Scans",
                CaptureNotes: false,
                ShowCheckButton: true,
                CaptureInfoForCodePrefix: '',
                AssignCategoryForCodePrefix: '',
            };
        },

        filteredLeads() {
            let leads = this.leads;

            if(!this.searchText) {
                return leads;
            }

            let toReturn = Array.from(this.leads);

            if(this.searchText && this.searchText.length > 0) {
                let searchTest = new RegExp(this.searchText, 'i');

                toReturn = toReturn.filter(x => {

                    return searchTest.test(x.Attendee.DisplayName);

                });
            }

            return toReturn;
        }

    },

    watch: {
        sectionCode() {
            this.build();
        },
        mode() {
            this.lastScannedText = null;
        },

    },

    methods: {
        updateLeadDisplayName() {
            this.lead.Attendee.DisplayName = `${this.lead.Attendee.FirstName || ''} ${this.lead.Attendee.LastName || ''}`.trim();
        },

        async build(){
            this.error = null;

            this.submitting = true;

            this.submitting = false;
        },

        editLead(lead) {
            this.lead = JSON.parse(JSON.stringify(lead));
        },

        async saveLeadScan() {
            if(!this.lead) {
                return;
            }

            this.submitting = true;

            try{
                let result = await this.tryPost(`/api/scan/vendor/${AppState.show.Sections[this.sectionCode].Code}`, JSON.stringify(this.lead), 'application/json');

                if(result && result.Result) {

                    if(this.settings.CaptureInfoForCodePrefix
                        && this.lead.Attendee.Code.indexOf(this.settings.CaptureInfoForCodePrefix) != -1) {
                       
                        let attendeeDetails = await this.tryGet(`/api/attendees/${this.lead.Attendee.Code}`);

                        let toFlash = attendeeDetails.Result.Attendee;

                        toFlash.FirstName = this.lead.Attendee.FirstName;
                        toFlash.LastName = this.lead.Attendee.LastName;
                        toFlash.DisplayName = this.lead.Attendee.DisplayName;
                        toFlash.ContactInfo.Title = this.lead.Attendee.Title;
                        toFlash.ContactInfo.SubTitle = this.lead.Attendee.SubTitle;
                        toFlash.Show = {
                            Code: this.showCode
                        };

                        if(this.settings.AssignCategoryForCodePrefix
                            && this.settings.AssignCategoryForCodePrefix.length > 0
                            && !toFlash.Categories.find(x => x.Code == this.settings.AssignCategoryForCodePrefix)) {
                            
                            toFlash.Categories.push({ Code: this.settings.AssignCategoryForCodePrefix });
                        }

                        let resultAttendee = await this.tryPost('/api/attendee', JSON.stringify(toFlash), 'application/json');
                    }

                    this.$awn.info("Scan saved.");
                    this.showScanSuccess();

                    this.lead = null;
                } else {
                    this.$awn.alert("Scan not saved. Please try again.");
                }
            } catch(ex){
                this.$awn.alert("Scan not saved. Please try again.");
            }

            if(this.settings.CaptureNotes) {
                this.lastScannedText = null;
            }


            this.submitting = false;
        },

        cancelSave() {
            this.lead = null;
            this.lastScannedText = null;
        },

        showScanSuccess() {
            if(this.scanSuccessCheckTimer) {
                clearTimeout(this.scanSuccessCheckTimer);
                this.scanSuccessCheckTimer = null;
            }

            this.showScanSuccessCheck = true;
            this.scanSuccessCheckFading = false;

            this.playScanSuccessBeep();

            this.scanSuccessCheckTimer = setTimeout(() => {
                this.scanSuccessCheckFading = true;

                this.scanSuccessCheckTimer = setTimeout(() => {
                    this.showScanSuccessCheck = false;
                    this.scanSuccessCheckFading = false;
                    this.scanSuccessCheckTimer = null;
                }, 250);
            }, 600);
        },

        playScanSuccessBeep() {
            try {
                const AudioContext = window.AudioContext || window.webkitAudioContext;

                if(!AudioContext) {
                    return;
                }

                const audioContext = new AudioContext();
                const oscillator = audioContext.createOscillator();
                const gain = audioContext.createGain();

                oscillator.type = 'sine';
                oscillator.frequency.setValueAtTime(880, audioContext.currentTime);
                gain.gain.setValueAtTime(0.08, audioContext.currentTime);
                gain.gain.exponentialRampToValueAtTime(0.001, audioContext.currentTime + 0.08);

                oscillator.connect(gain);
                gain.connect(audioContext.destination);
                oscillator.start();
                oscillator.stop(audioContext.currentTime + 0.08);
                oscillator.onended = () => audioContext.close();
            } catch {

            }
        },

        async checkScanAsync(showCode, attendeeCode) {
            // Query the API to get the scan history for the attendee
            this.submitting = true;
            this.qrCheckResults = null;

            try {
                let result = await this.tryGet(`/api/scans/${showCode}/check/custom/${this.settings.CustomScanCode}/${attendeeCode}`)

                let qrCheckResults = {
                    Title: '❌ Not Scanned',
                    ScanDateTime: null,
                };

                if(result.Result) {
                    qrCheckResults.ScanDateTime = moment(result.Result.ScanDateTimeUtc).format('MMM DD h:mm a');

                    qrCheckResults.Title = '✅ Scan Found'
                }

                this.qrCheckResults = qrCheckResults;
            } catch(ex) {
                console.log(ex);
                this.$awn.alert("Could not retrieve scan results. Please try again later.");
            }

            this.submitting = false;
        },        

        async getLeadsAsync() {
            this.submitting = true;
            
            this.submitting = false;
        },

        async onScanSuccess(result) {

            if(this.lead) {
                return;
            }

            if(this.lastScannedText == result.data) {
                this.scanStatus = "Successfully Scanned";
                return;
            }

            this.scanStatus = "";

            this.lastScannedText = result.data;

            let attendeeBadge = parseAttendeeBadgeScan(this.lastScannedText);

            if(attendeeBadge) {
                let attendeeCode = attendeeBadge.attendeeCode;
                let showCode = attendeeBadge.showCode;

                this.submitting = true;

                if(showCode != AppState.showCode) {
                    this.$awn.alert("This badge is not for this show.");
                    this.submitting = false;
                    return;
                }

                if(result._keyboardInput || this.mode == 'scanner') {

                    let lead = await this.tryGet(`/api/scans/${showCode}/check/vendor/${this.settings.CustomScanCode}/${attendeeCode}`);

                    this.submitting = false;

                    if(!lead || !lead.Result) {
                        this.$awn.alert("Sorry. QR code not recognized.");
                        return;
                    }

                    


                    this.lead = lead.Result;
                    this.showScanSuccess();

                    if(this.settings.CaptureInfoForCodePrefix 
                        && this.settings.CaptureInfoForCodePrefix.length > 0
                        && attendeeCode.indexOf(this.settings.CaptureInfoForCodePrefix) != -1) {

                        this.allowEditInformation = true;

                    } else if(!this.settings.CaptureNotes) {
                        this.saveLeadScan();
                    }

                } else if(this.mode == 'check') {

                    await this.checkScanAsync(showCode, attendeeCode);
                }

            } else {
                this.$awn.alert("Sorry. QR code not recognized.");
            }
            

        },

        async switchToScanMode() {
            this.mode = 'scanner';
            this.scanner = new QrScanner(
                this.$refs.qrFeed,
                this.onScanSuccess,
                {
                    highlightCodeOutline: true,
                    highlightScanRegion: true,
                    preferredCamera: 'environment',
                    maxScansPerSecond: 5
                });

            this.scanner.start();

            window.$signalRConnection.invoke(
                'UnregisterForPageAnalytics', 
                `${AppState.showCode}_${this.settings.CustomScanCode}_LEADS`.toUpperCase());

        },

        async switchToLeadMode() {
            if(this.scanner) {
                this.scanner.stop();
                this.scanner = null;
            }

            this.mode = 'leads';

            this.connectToControlChannel();

            this.reloadLeads();
        },

        async reloadLeads() {
            this.submitting = true;

            try {
                let result = await this.tryGet(`/api/scans/${this.showCode}/check/vendor/${this.settings.CustomScanCode}`);
                this.leads = result.Result || [];
            } catch {
                this.$awn.alert("Could not reload the lead list.");
            }

            this.submitting = false;
        },

        async connectToControlChannel(){
            if(window.$signalRConnection.notInitialized) {
                return;
            }

            if(this.mode != 'leads') {
                return;
            }

            window.$signalRConnection.invoke(
                'RegisterForPageAnalytics', 
                `${AppState.showCode}_${this.settings.CustomScanCode}_LEADS`.toUpperCase());
        },

        onLeadCaptured(lead) {
            if(!lead) {
                return;
            }

            if(lead.VendorCode != this.settings.CustomScanCode) {
                return;
            }

            let existingLead = this.leads.find(x => x.AttendeeCode == lead.AttendeeCode);

            if(!existingLead) {
                this.leads.push(lead);
            } else {
                Object.assign(existingLead, lead);
            }
        },

        exportToCsv() {
            let csvFile = 'Name,Title,SubTitle,ScanDatetimeUtc,Notes\n';

            this.leads.forEach(lead => {
                console.log(lead)
                csvFile += `"${lead.Attendee.DisplayName?.replace('"', '') || ''}","${lead.Attendee.Title?.replace('"', '') || ''}","${lead.Attendee.SubTitle?.replace('"', '') || ''}","${lead.ScanDateTimeUtc?.replace('"', '') || ''}","${lead.Notes?.replace('"', '') || ''}"\r\n`;
            });

            let blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });

            let link = document.createElement("a");
            if (link.download !== undefined) { // feature detection
                // Browsers that support HTML5 download attribute
                let url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", 'export_leads.csv');
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }

            this.$awn.info('Exported leads to CSV. Please check your downloads.');
        },

        onKeyStroke(e) {
            if(!this.scannerInput) {
                this.scannerInput = '';
            }

            console.log("Got input", e.key, this.scannerInput);
            const whitelistedKeys = /^[A-Za-z0-9&?=;:,.\/]$/;

            if(e.key === 'Enter') {
                let toCheck = this.scannerInput;
                this.scannerInput = '';
                if(!parseAttendeeBadgeScan(toCheck)) {
                    return;
                }
                console.warn("Got an attendee barcode!")
                console.log(toCheck);
                this.onScanSuccess({data: toCheck, _keyboardInput: true});
            } else if(whitelistedKeys.test(e.key)) {
                this.scannerInput += e.key;
            } else if(this.scannerInput && this.scannerInput.length > 512) {
                // Reset since our scans should never be this long.
                this.scannerInput = '';
            }
        }
    },

    beforeUnmount() {
        document.removeEventListener("keydown", this.onKeyStroke);
        window.$bus.$off('connected-to-signalr', this.connectToControlChannel);       
        window.$bus.$off('LeadCaptured', this.onLeadCaptured);    

        if(this.scanSuccessCheckTimer) {
            clearTimeout(this.scanSuccessCheckTimer);
            this.scanSuccessCheckTimer = null;
        }

        if(this.scanner) {
            this.scanner.stop();
        }

        window.$signalRConnection.invoke(
            'UnregisterForPageAnalytics', 
            `${AppState.showCode}_${this.settings.CustomScanCode}_LEADS`.toUpperCase());
    },

    async mounted() {
        window.$bus.$on('connected-to-signalr', this.connectToControlChannel);
        window.$bus.$on('LeadCaptured', this.onLeadCaptured);    

        document.addEventListener("keydown", this.onKeyStroke);
        await this.build();
    }

}
</script>
